export const NavItems = [
    {
      title: "About Us",
      url: "/aboutUs",
      cName: "navlinks"
    },
    {
        title: "Our Values",
        url: "/values",
        cName: "navlinks"
      },
    // {
    //   title: "Track process",
    //   url: "/process",
    //   cName: "navlinks"
    // }, 
      {
        title: "Contacts",
        url: "/contact",
        cName: "navlinks"
      },
  ];
  